// The portal starts: its config, then signing in, the API's cache and the pages.
import './design/index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { router } from './app';
import { AuthProvider } from './auth';
import { loadConfig } from './config';
import { FeedbackProvider } from './ui';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: true } },
});

const root = createRoot(document.getElementById('root') as HTMLElement);

loadConfig().then(
  (config) =>
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <AuthProvider config={config}>
            <FeedbackProvider>
              <RouterProvider router={router} />
            </FeedbackProvider>
          </AuthProvider>
        </QueryClientProvider>
      </StrictMode>,
    ),
  () =>
    root.render(
      <main className="page-content">
        <p>TUNE Analytics couldn't start. Reload the page to try again.</p>
      </main>,
    ),
);
